import { gql } from "apollo-boost"

export default gql`
  subscription ChatRoomMessage($chatRoomId: ID!) {
    chatRoomMessage(chatRoomId: $chatRoomId) {
      id
      content
      sender {
        id
        name
      }
      type
      isRead
      fileName
      chatRoom {
        assistant {
          id
          name
        }
      }
      createdAt
    }
  }
`
